/**
 * "Environments & promotion" — Dashboard section (ADR-0074).
 * Reconciled from apps/web environments feature (Dev/Prod, promote-with-diff,
 * eval report).
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_ENVIRONMENTS_PAGE: DocPageContent = {
  slug: 'dashboard/environments',
  titleKey: 'docs.dashboard.environments.title',
  descriptionKey: 'docs.dashboard.environments.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.environments.lead' },

    { kind: 'heading', level: 2, id: 'two', textKey: 'docs.dashboard.environments.two.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.environments.two.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'promote',
      textKey: 'docs.dashboard.environments.promote.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.environments.promote.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.environments.gate.title',
      textKey: 'docs.dashboard.environments.gate.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.environments.next.team.title',
          textKey: 'docs.dashboard.environments.next.team.text',
          to: { docSlug: 'dashboard/team' },
        },
        {
          titleKey: 'docs.dashboard.environments.next.catalog.title',
          textKey: 'docs.dashboard.environments.next.catalog.text',
          to: { docSlug: 'dashboard/catalog' },
        },
      ],
    },
  ],
};
